import type { ConciseBranch } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import cx from 'classnames'

import { BranchCategoryIcon } from './BranchCategoryIcon'

type Props = {
  specification: ConciseBranch
  className?: string
  label?: Optional<string>
}

export const BranchNameAndCategory = ({
  specification,
  className,
  label,
}: Props) => (
  <div className={cx('flex gap-x-2', className)}>
    <BranchCategoryIcon category={specification.branchCategory} />
    <div>{label ?? specification.name ?? ''}</div>
  </div>
)
